import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'
import { defineSaleProgress, isSaleSigned, isSaleStarted, type ProgressSaleData } from '../saleProgress'

interface AssistanceData extends ProgressSaleData {
  assistanceId?: number | string | null
  presentationAccepted?: boolean
  axaEmailAlreadySent?: boolean
}

const TIMELINE = 'additionalSales:pulse.timeline.'

export default defineSaleProgress<AssistanceData>({
  kind: 'sale',
  cascade: true,
  pandaDoc: true,
  steps: ({ country }) => [
    { key: 'accord', label: `${TIMELINE}accord`, done: data => !!data.presentationAccepted },
    ...(modulesConfig[country as keyof typeof modulesConfig]?.additionalSales?.axaInfoEmail
      ? [
          {
            key: 'offer_sent',
            label: `${TIMELINE}offer_sent`,
            done: (data: AssistanceData) => !!data.axaEmailAlreadySent,
          },
        ]
      : []),
    { key: 'sms_code', label: `${TIMELINE}sms_code`, done: isSaleStarted },
    { key: 'signature', label: `${TIMELINE}signature`, done: isSaleSigned },
  ],
  formulaId: data => data.assistanceId,
})
